module.exports = __webpack_public_path__ + "img/itch-io.ca759ba4.svg";